// src/pages/Bestsellers/BeforeAfterSlider.jsx
import React, { useState, useRef, useEffect } from 'react';
import './BeforeAfterSlider.css';

const BeforeAfterSlider = ({ data }) => {
  const [sliderPosition, setSliderPosition] = useState(50);
  const [isDragging, setIsDragging] = useState(false);
  const containerRef = useRef(null);

  // Call useEffect at the top level (before any conditional returns)
  useEffect(() => {
    const handleGlobalMouseUp = () => setIsDragging(false);
    window.addEventListener('mouseup', handleGlobalMouseUp);
    return () => window.removeEventListener('mouseup', handleGlobalMouseUp);
  }, []);

  // If no data or empty array, don't render
  if (!data || data.length === 0) {
    return null;
  }

  // Use the first item from the data array
  const item = data[0];
  
  const beforeImage = item?.beforeImageUrl ? 
    (item.beforeImageUrl.startsWith('http') ? item.beforeImageUrl : 
     `https://volumaire.backendapihub.com${item.beforeImageUrl}`) : 
    'https://wonder-theme-beauty.myshopify.com/cdn/shop/files/beauty-before.jpg?v=1734648129&width=1500';
  
  const afterImage = item?.afterImageUrl ? 
    (item.afterImageUrl.startsWith('http') ? item.afterImageUrl : 
     `https://volumaire.backendapihub.com${item.afterImageUrl}`) : 
    'https://wonder-theme-beauty.myshopify.com/cdn/shop/files/beauty-after.jpg?v=1734648145&width=1500';

  const handleMove = (clientX) => {
    if (!containerRef.current) return;
    
    const rect = containerRef.current.getBoundingClientRect();
    const x = clientX - rect.left;
    const percentage = (x / rect.width) * 100;
    
    setSliderPosition(Math.min(Math.max(percentage, 0), 100));
  };

  const handleMouseDown = () => setIsDragging(true);
  const handleMouseUp = () => setIsDragging(false);

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    handleMove(e.clientX);
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    handleMove(e.touches[0].clientX);
  };

  return (
    <>
      <link 
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" 
        rel="stylesheet"
      />
      
      <div className="before-after-section">
        <div className="container-fluid">
          <div className="row g-0">
            {/* Left Side - Text */}
            <div className="col-md-6">
              <div className="text-side">
                <h1 className="heading-text">
                  {item?.textHeader || 'We know you are unique.'}
                </h1>
                <p className="desc-text">
                  Take care of your complexion to make it healthy and radiant. In the range of facial care products you will find creams, scrubs, masks, toners, gels and much more.
                </p>
              </div>
            </div>

            {/* Right Side - Slider */}
            <div className="col-md-6">
              <div 
                ref={containerRef}
                className="image-slider"
                onMouseMove={handleMouseMove}
                onTouchMove={handleTouchMove}
                onMouseUp={handleMouseUp}
                onTouchEnd={handleMouseUp}
              >
                {/* Before Image */}
                <div className="img-layer">
                  <img 
                    src={beforeImage}
                    alt="Before" 
                    className="slider-img"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "https://wonder-theme-beauty.myshopify.com/cdn/shop/files/beauty-before.jpg?v=1734648129&width=1500";
                    }}
                  />
                </div>

                {/* After Image */}
                <div 
                  className="img-layer img-layer-top"
                  style={{
                    clipPath: `inset(0 ${100 - sliderPosition}% 0 0)`
                  }}
                >
                  <img 
                    src={afterImage}
                    alt="After" 
                    className="slider-img"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "https://wonder-theme-beauty.myshopify.com/cdn/shop/files/beauty-after.jpg?v=1734648145&width=1500";
                    }}
                  />
                </div>

                {/* Slider */}
                <div 
                  className="slider-bar"
                  style={{ left: `${sliderPosition}%` }}
                >
                  <div 
                    className="slider-btn"
                    onMouseDown={handleMouseDown}
                    onTouchStart={handleMouseDown}
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                      <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                      <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </div>

                {/* Labels in corners */}
                <div className="corner-label left-label">Before</div>
                <div className="corner-label right-label">After</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BeforeAfterSlider;